import React from 'react'

interface IProps {
  title: string,
  setShowModalForm: React.Dispatch<React.SetStateAction<boolean>>
  action: any
}

const ModalForm:React.FC<IProps> = ({setShowModalForm, title, action}) => {
  return (
    <div className='fixed top-0 bottom-0 left-0 right-0 bg-slate-500 flex justify-center opacity-90 items-center z-50'>
      <div className= 'flex flex-col justify-center items-center bg-slate-900 w-96 h-60 rounded-md p-8'>
        <h2 className='pb-8 text-xl md:text-2xl'>{title}</h2>
        <div className='space-x-8'>
          <button className=' border-2 border-slate-300 px-4 md:px-8 py-2 rounded-md bg-red-400 hover:cursor-pointer hover:bg-red-500' onClick={(event)=>{
            event.stopPropagation()
            action()
          }} >Yes</button>
          <button className=' border-2 border-slate-300 px-4 md:px-8 py-2 rounded-md hover:cursor-pointer hover:bg-slate-700' onClick={(event)=> {  
            event?.stopPropagation()
            setShowModalForm(false) }}>No</button>
        </div>
      </div>
    </div>
  )
}

export default ModalForm